import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import Navigation from './Navigation';
import Footer from './Footer';
import ContactForm from './ContactForm';
import { teamInfo, leadershipTeam, faqs } from '../mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const ContactPage = () => {
  return (
    <div className="page-container">
      <Navigation />
      
      <main className="main-content">
        <section className="page-hero">
          <div className="container">
            <h1 className="page-title">Contact Us</h1>
            <p className="page-subtitle">Have questions? We'd love to hear from you!</p>
          </div>
        </section>

        {/* Contact Grid */}
        <section className="contact-main-section">
          <div className="container">
            <div className="contact-main-grid">
              {/* Contact Form */}
              <div className="contact-form-wrapper">
                <h2>Send Us a Message</h2>
                <ContactForm />
              </div>

              {/* Contact Info */}
              <div className="contact-info-wrapper">
                <Card className="contact-info-card">
                  <CardContent>
                    <h3>Contact Information</h3>
                    <div className="contact-item">
                      <Mail size={20} />
                      <div>
                        <div className="contact-label">Email</div>
                        <a href={`mailto:${teamInfo.email}`}>{teamInfo.email}</a>
                      </div>
                    </div>
                    <div className="contact-item">
                      <Phone size={20} />
                      <div>
                        <div className="contact-label">Coach Chris</div>
                        <a href={`tel:${teamInfo.phone.coach_chris}`}>{teamInfo.phone.coach_chris}</a>
                      </div>
                    </div>
                    <div className="contact-item">
                      <Phone size={20} />
                      <div>
                        <div className="contact-label">Coach Kenny</div>
                        <a href={`tel:${teamInfo.phone.coach_kenny}`}>{teamInfo.phone.coach_kenny}</a>
                      </div>
                    </div>
                    <div className="contact-item">
                      <MapPin size={20} />
                      <div>
                        <div className="contact-label">Address</div>
                        <span>{teamInfo.address}</span>
                      </div>
                    </div>

                    <div className="social-section">
                      <h4>Follow Us</h4>
                      <div className="social-links">
                        <a href={teamInfo.social.facebook} target="_blank" rel="noopener noreferrer" className="social-link">
                          <Facebook size={24} />
                          <span>Facebook</span>
                        </a>
                        <a href={teamInfo.social.instagram} target="_blank" rel="noopener noreferrer" className="social-link">
                          <Instagram size={24} />
                          <span>Instagram</span>
                        </a>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
        </section>

        {/* Leadership Team */}
        <section className="leadership-section">
          <div className="container">
            <h2 className="section-title">Leadership Team</h2>
            <div className="leadership-grid">
              {leadershipTeam.map((leader) => (
                <Card key={leader.id} className="leader-card">
                  <CardContent>
                    {leader.photo ? (
                      <div className="leader-avatar" style={{ backgroundImage: `url(${leader.photo})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                      </div>
                    ) : (
                      <div className="leader-avatar">
                        {leader.name.split(' ').map(n => n[0]).join('')}
                      </div>
                    )}
                    <h3>{leader.name}</h3>
                    <div className="leader-title">{leader.title}</div>
                    <p>{leader.bio}</p>
                    {leader.phone && (
                      <a href={`tel:${leader.phone}`} className="leader-phone">
                        <Phone size={16} /> {leader.phone}
                      </a>
                    )}
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="faq-section">
          <div className="container">
            <h2 className="section-title">Frequently Asked Questions</h2>
            <div className="faq-wrapper">
              <Accordion type="single" collapsible className="faq-accordion">
                {faqs.map((faq) => (
                  <AccordionItem key={faq.id} value={`faq-${faq.id}`}>
                    <AccordionTrigger>{faq.question}</AccordionTrigger>
                    <AccordionContent>{faq.answer}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ContactPage;
